import styled from 'styled-components';
import { useGovernmentHeaderStore } from 'store/useGovernmentHeaderStore';
import { BorderColor } from 'styles/Global/colorSemantic';
import { zIndex } from 'styles/Global/globalStyles';
import { Body2Bold, Body2BoldSection } from 'styles/Global/typography';
import IcMenu from 'assets/Icons/Menu/IcMenu';
import { MindUpAdminMobileAllReservationConsultationMenu } from './constants';
import { Tap } from 'components/DesignSystem/Tap/Tap';
import { MindUpAdminMobileAllReservationConsultationHeaderProps } from 'models/MindUpMobileAdmin/MindUpAdminMobileAllReservationConsultationPageTypes';
import IcAccountFillOn from 'assets/Icons/Account/IcAccountFillOn';
import { useNavigate } from 'react-router-dom';
import { mindupAdminMobilePaths } from 'constants/path';

const MindUpAdminMobileAllReservationConsultationHeader = ({ menu, setMenu, onClick }: MindUpAdminMobileAllReservationConsultationHeaderProps) => {
    const navigate = useNavigate();

    return (
        <Layout>
            <TitleContainer>
                예약 대기 상담
                <FlexWrapper>
                    <button onClick={() => navigate(mindupAdminMobilePaths.MindUpAdminMobileAccountSetting)}>
                        <IcAccountFillOn />
                    </button>
                    <button onClick={onClick}>
                        <IcMenu />
                    </button>
                </FlexWrapper>
            </TitleContainer>
            <DiagnosisTapsContainer>
                {MindUpAdminMobileAllReservationConsultationMenu.map((item, idx) => {
                    const count = MindUpAdminMobileAllReservationConsultationMenu.length;

                    return (
                        <Tap key={idx} onClick={() => setMenu(idx)} $idx={idx} $selected={menu === idx ? menu : undefined} $count={count}>
                            {item}
                        </Tap>
                    );
                })}
            </DiagnosisTapsContainer>
        </Layout>
    );
};

export default MindUpAdminMobileAllReservationConsultationHeader;

const Layout = styled(Body2BoldSection)`
    display: flex;
    position: fixed;
    flex-direction: column;
    top: 0;
    left: 50%; // 왼쪽에서 50% 위치로 이동
    transform: translateX(-50%);
    z-index: ${zIndex.floating + 1};
    min-width: 360px;
    max-width: 576px;
    width: 100%;
    height: 96px;
    background-color: white;

    // &::after {
    //     content: '';
    //     position: absolute;
    //     bottom: 0;
    //     left: 0;
    //     width: 100%;
    //     height: 1px; /* border-bottom의 두께 */
    //     background: linear-gradient(180deg, ${BorderColor.color_border_normal}, ${BorderColor.color_border_weak}, ${BorderColor.color_border_neutral});
    // }
`;

const TitleContainer = styled(Body2Bold)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 16px;
    height: 56px;
`;

const FlexWrapper = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    gap: 20px;
`;

const DiagnosisTapsContainer = styled.div`
    display: flex;
    height: 40px;
    width: 100%;
`;
